<template>
    <div class="wrap">
        <a
            class="btn-1 mt-15"
            href="/about"
            @mouseenter="(event) => updatePosition(event, 'enter')"
            @mouseout="(event) => updatePosition(event, 'leave')"
            >
            <small ref="textBtn" class="text-btn-1">{{ $t('Read More') }}</small>
            <span ref="effectSpan"></span>
        </a>
    </div>
</template>
<script>
import { ref } from 'vue';

export default {
  name: 'ButtonReadmore',
  setup() {
    const effectSpan = ref(null);
    const textBtn = ref(null);  // Ref para el texto del botón

    const updatePosition = (event, action) => {
      const button = event.currentTarget;
      const rect = button.getBoundingClientRect();
      const relX = event.pageX - rect.left - window.scrollX;
      const relY = event.pageY - rect.top - window.scrollY;

      if (effectSpan.value) {
        effectSpan.value.style.top = `${relY}px`;
        effectSpan.value.style.left = `${relX}px`;
      }

      if (textBtn.value) {
        if (action === 'enter') {
          textBtn.value.classList.add('fade-out-up', 'opacityout');
        } else if (action === 'leave') {
            textBtn.value.classList.add('opacityin');
            textBtn.value.classList.remove('fade-out-up');
            setTimeout(() => textBtn.value.classList.remove('fade-in-down', 'opacityout'), 50);
          
        }
      }
    };

    return {
      effectSpan,
      textBtn,
      updatePosition,
    };
  },
};
</script>



<style scoped>
[class^="btn-"] {
    position: relative;
    display: inline-block;
    overflow: hidden;
    width: 100%; /* Se asume un valor fijo para el ancho del botón */
    height: auto;
    padding: 12px 100px;
    max-width: 300px; /* Reemplaza $btn-width con un valor real */
    margin: 1rem auto;
    text-transform: uppercase;
    text-align: center;
    
}

span {
    transition: none;
  }

.btn-1 {
    position: relative;
    border: 1px solid rgba(255, 255, 255, 0.06);
    border-radius: 80px;
    background-color: rgba(255, 255, 255, 0.1); /* Fondo translúcido neutro */
    backdrop-filter: blur(10px); /* Efecto de desenfoque */
    -webkit-backdrop-filter: blur(10px); /* Compatibilidad con Safari */
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1); /* Sombra para realce */
    -webkit-transition: color 400ms ease, background-color 400ms ease;
    transition: color 0.2s ease-in-out, background-color 400ms ease-in-out;
    color: #fff;
    overflow: hidden; /* Oculta los elementos fuera del botón */
}

.btn-1 span {
    position: absolute;
    top: 50%;
    left: 50%;
    display: block;
    width: 0;
    height: 0;
    border-radius: 50%;
    background-color: #fff; /* Color oscuro para el efecto de expansión */
    transition: width 0.4s ease-in-out, height 0.4s ease-in-out;
    transform: translate(-50%, -50%);
    z-index: -1;
}

.btn-1:hover {
  color: rgba(0, 0, 0, 0.75);
}

.btn-1:hover span {
    width: 225%;
    height: 225%;
}

.btn-1:active {
    background-color: #fff; /* Mismo color que el de expansión */
}



.text-btn-1 {
  display: inline-block;
  transition: transform 0.4s ease, opacity 0.4s ease;
}

.traslatenormal{
    transform: translateY(0);
}

.opacityin {
  opacity: 1;
}

.opacityout {
  opacity: 0;
}

.fade-out-up {
  transform: translateY(-20px);
}

.fade-in-down {
  transform: translateY(20px);
}

/* Consultas de medios para diferentes tamaños de pantalla */
@media (max-width: 768px) {
    [class^="btn-"] {
        padding: 10px 15px;
        max-width: 100%;
    }

    .btn-1 span {
        transition: width 0.3s ease, height 0.3s ease;
    }
}

@media (max-width: 480px) {
    [class^="btn-"] {
        padding: 20px 12px;
        font-size: 14px;
    }
}
</style>